export class Dispatcher {
  static $dispatch() {}
}
